import { customAxios, IDUSUARIO, ENTREGAS_URL } from '../constants';

export default function(pedido,varFilial='',varlugar='') {
  let config ={};
  let valueFilial ='';



  if(pedido[0] !== undefined){
    if(varlugar === '1'){
      valueFilial =  varFilial;
    }else{
      valueFilial = pedido[0].codFilial
   
    }


   config = {
    params: {
      codArea:pedido[0].codAreaVta,
      codFamilia:pedido[0].codFamiliaVeh,
      codFilial:valueFilial,
      codMarca:pedido[0].codMarca,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  }else{
    config = {
      params: {
        codArea:'',
        codFamilia:'',
        codFilial:'',
        codMarca:'',
      },
      headers: {
        idUsuario: IDUSUARIO,
      },
    };
  }
  return customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo/usuarioRol/roles/usuarios`, config);
}



// WEBPACK FOOTER //
// ./src/utils/getEspecialista.js